import request from '@/network/http'

export function getCheckupCategoryList(data) {
    return request({
        url: 'Checkup/CheckupCategory/getCheckupCategoryList',
        method: 'post',
        data
    })
}

export function getCheckupCategoryTreeList() {
    return request({
        url: 'Checkup/CheckupCategory/getCheckupCategoryTreeList',
        method: 'post'
    })
}

export function deleteCheckupCategoryInfo(data) {
    return request({
        url: 'Checkup/CheckupCategory/deleteCheckupCategoryInfo',
        method: 'post',
        data
    })
}

export function saveCheckupCategoryInfo(data) {
    return request({
        url: 'Checkup/CheckupCategory/saveCheckupCategoryInfo',
        method: 'post',
        data
    })
}

export function getCheckupCategoryDetail(data) {
    return request({
        url: 'Checkup/CheckupCategory/getCheckupCategoryDetail',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/apis/classInformation.js